import React from "react";

import { IOption } from "src/components/Dropdown/Dropdown";

import "./OptionButtons.scss";

/** Largest option list that reads well as a row of buttons; longer lists stay in a Dropdown. */
export const OPTION_BUTTONS_MAX = 6;

export const fitsOptionButtons = (options: IOption[]): boolean =>
  options.length > 0 && options.length <= OPTION_BUTTONS_MAX;

interface IProps {
  label: string,
  options: IOption[],
  value: IOption,
  onChange(e: React.MouseEvent<HTMLButtonElement>, value: IOption): void,
  error?: boolean,
  disabled?: boolean,
  className?: string,
  id?: string
}

/**
 * Single-select control for a small set of options. Every option is shown as a
 * full-height button, so a choice is one tap instead of open-scroll-pick. Takes the
 * same `label` / `options` / `value` / `onChange` props as `Dropdown`.
 */
const OptionButtons: React.FC<IProps> = (props) => {
  const classes = ["OptionButtons"];
  if (props.error) classes.push("error");
  if (props.disabled) classes.push("disabled");
  if (props.className) classes.push(props.className);

  return (
    <div className={classes.join(" ")} id={props.id}>
      <label><span title={props.label}>{props.label}</span></label>
      <div className="buttons" role="radiogroup" aria-label={props.label}>
        {props.options.map((option: IOption) => {
          const selected = option.id === props.value?.id;
          const disabled = props.disabled || option.disabled;
          return (
            <button
              key={option.id}
              type="button"
              role="radio"
              aria-checked={selected}
              disabled={disabled}
              className={selected ? "option selected" : "option"}
              onClick={(e) => { if (!disabled) props.onChange(e, option); }}
            >
              {option.value}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default OptionButtons;
